import React from 'react';

export default function IconYesActive() {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M109.821 45.3857C116.25 38.204 116.25 27.0199 109.821 19.8382C102.766 11.9587 90.7942 11.9587 83.7398 19.8382L47.7399 60.0486L36.2602 47.2262C29.2058 39.3467 17.2338 39.3467 10.1794 47.2262C3.74969 54.4079 3.7497 65.5921 10.1794 72.7738L34.6995 100.162C41.754 108.041 53.7259 108.041 60.7803 100.162L109.821 45.3857Z"
        fill="#E6F5EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.836 26.0916C99.5078 22.3743 94.0526 22.3743 90.7245 26.0916L49.1369 72.5433C48.7812 72.9406 48.2732 73.1676 47.7399 73.1676C47.2067 73.1676 46.6987 72.9406 46.343 72.5433L29.2755 53.4796C25.9474 49.7623 20.4922 49.7623 17.1641 53.4796C13.9215 57.1015 13.9215 62.8986 17.1641 66.5205L41.6842 93.9085C45.0123 97.6258 50.4675 97.6258 53.7956 93.9085L102.836 39.1324C106.078 35.5106 106.078 29.7135 102.836 26.0916ZM105.63 23.5902L104.233 24.8409L105.63 23.5902C110.147 28.636 110.147 36.5879 105.63 41.6338L104.348 40.4859L105.63 41.6338L56.5895 96.4098C51.7709 101.792 43.709 101.792 38.8903 96.4098L14.3702 69.0218C9.85275 63.976 9.85275 56.0241 14.3702 50.9783C19.1888 45.596 27.2507 45.596 32.0694 50.9783L47.7399 68.4816L87.9306 23.5902C92.7492 18.208 100.811 18.208 105.63 23.5902Z"
        fill="#0E7A4A"
      />
    </svg>
  );
}
